export const PRODUCT_NAMES = {
  BBProduct: 'Business Broadband Access',
  CVEProduct: 'BT Cloud Voice Site Number',
};

export const PRODUCT_TYPES = {
  BBProduct: 3,
  CVEProduct: 11,
};
